import { Component, Input } from '@angular/core';
import { UserContext } from '@core/models';
import * as ProgramCodeConstants from '@core/constants/program-code-constants';

@Component({
  selector: 'sp-dashboard-no-paystubs',
  template: `
    <div class="dashboard-no-paystubs-container">
      <h2>You’ll see a summary here after you receive your first paycheck.</h2>
      <div class="no-paystubs-svg">
        <img [src]="imageSrc" class="svg-content" />
      </div>
    </div>
  `,
  styleUrls: ['./dashboard-no-paystubs.scss'],
})
export class DashboardNoPaystubsComponent {
  imageSrc = 'assets/pay-details/sure-no-paycheck.svg';

  @Input() set userContext(context: UserContext) {
    const programCode = context.programCode.toLowerCase();
    if (
      ProgramCodeConstants.SurepayrollProgramCodeConstants.indexOf(programCode) >= 0 ||
      ProgramCodeConstants.RunpayrollProgramCodeConstants.indexOf(programCode) >= 0
    ) {
      this.imageSrc = `assets/pay-details/sure-no-paycheck.svg`;
    } else if (ProgramCodeConstants.PaychexProgramCodeConstants.indexOf(programCode) >= 0) {
      this.imageSrc = `assets/pay-details/pxgo-no-paycheck.svg`;
    } else if (ProgramCodeConstants.TruistProgramCodeConstants.indexOf(programCode) >= 0) {
      this.imageSrc = `assets/pay-details/sunt-no-paycheck.svg`;
    }
  }
}
